<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_LIQ_DEFINITIVA"/>
          LIQUIDACIÓN DEFINITIVA
        </span>
        <g-master name="empdef"
                  @params="paramsTable"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  modalWidth="80%"
                  ref="master"
                  @action="masterAction"
                  :actions="master.actions"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
        <div v-if="text ==='CERRADO'">
          <a-tag color="red">{{text}}</a-tag>
        </div>
        <div v-if="text ==='LIQUIDADO'">
          <a-tag color="blue">{{text}}</a-tag>
        </div>
      </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados_liquidacion_definitiva"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Motivo de terminación')"
                            :formItemConfig="fiOptions"
                            :decorator="['termination_reason', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="id_h_termination_cause"></g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha de terminación')">
                  <a-date-picker style="width: 100%"
                                 format="YYYY-MM-DD"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['termination_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha de pago')">
                  <a-date-picker style="width: 100%"
                                 format="YYYY-MM-DD"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['pay_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Año')" v-bind="fiOptions">
                  <a-select v-decorator="['year', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: true, message: 'Valor requerido'},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Período')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="period_request">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Proceso')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['prc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="proceso">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Indemnización')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['indemnization', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'S' }]"
                            :params="estado">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Confidencial')"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup"
                            :decorator="['confidential', { rules: [{ required: false, message: 'Valor requerido' }], initialValue: 'S' }]"
                            :params="estado">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha límite de novedad')">
                  <a-date-picker style="width: 100%"
                                 format="YYYY-MM-DD"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['limit_nov_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Estado')">
                  <a-input
                    style="width: 100%"
                    :disabled="true"
                    v-decorator="['estado_quemado', {rules: [{ required: false }], initialValue: 'LIQUIDADO' }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Comentarios')" v-bind="fiOptions">
                  <a-textarea
                    autoSize
                    v-decorator="['comments', { rules: [{ required: false }] }]">
                  </a-textarea>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Ausentismo" key="1">
        <ausentismo v-if="id_emp" :empleadoseleccionado="id_emp"/>
        <span v-else>Seleccione una Liquidacion Definitiva para ver más.</span>
      </a-tab-pane>
    </a-tabs>
    <template>
      <a-modal v-model="visible" title="Tiempo límite" :footer="null">
        <a-result status="warning"
                  title="La fecha de Novedad ha caducado para el Calendario de Nomina Activo, por favor consulte su administrador HRO">
          <template #extra>
            <a-button @click="handleOk" type="primary">
              Cerrar
            </a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
      this.limiteRegistroNovedad()
    },
    data () {
      return {
        mostrarNuevaListaMotTerminacionLiqDef: this.$getConfigValue('USAR_NUEVA_LISTA_MOTIVO_TERMINACION_EN_LIQ_DEF', 'NO') === 'SI',
        visible: false,
        estado: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        id_h_termination_cause: {
          h_lookup_type: 'CAUSA_RETIRO',
          use_code: true
        },
        proceso: {
          h_lookup_type: 'PROCESOS_LIQ_DEF',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        horas: '',
        inicio: null,
        fin: null,
        visibleHoras: false,
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        years: [],
        yearToday: parseInt(moment().format('YYYY')),
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          actions: [],
          valoresExpandidos: [
            {label: 'ID proceso', column: 'prc'},
            {label: 'Proceso', column: 'proceso'},
            {label: 'Fecha de pago', column: 'fecha_pago'},
            {label: 'Confidencial', column: 'confidencial'},
            {label: 'Fecha límite de novedad', column: 'fecha_limite'},
            {label: 'Fecha contrato', column: 'fecha_contrato'},
            {label: 'Tipo de pago', column: 'tipo_pago'},
            {label: 'Comentarios', column: 'comments'}
          ],
          endpoint: 'emp_def',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if ((record.def_status === 'CER' && this.$userIsInrol('AdminNomina')) || record.def_status !== 'CER') { return true }
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.def_status !== 'CER') { return true }
                  }
                }
              ]
            },
            customSlots: ['expandedRowRender', 'estadoRenderer'],
            tableConfig: {
              rowKey: 'id_def'
            },
            columns: [
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_completo', sorter: true},
              {title: 'Motivo de terminación', dataIndex: 'causa_terminacion', sorter: true},
              {title: 'Fecha de terminación', dataIndex: 'fecha_terminacion', sorter: true},
              {title: 'Indemnización', dataIndex: 'indemnizacion', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'ID período', dataIndex: 'period', sorter: true},
              {title: 'Período', dataIndex: 'periodo', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'termination_reason'},
            {name: 'termination_date'},
            {name: 'period'},
            {name: 'year'},
            {name: 'month'},
            {name: 'pay_date'},
            {name: 'indemnization'},
            {name: 'confidential'},
            {name: 'estado_quemado'},
            {name: 'prc'}
          ],
          estado_def: 'LIQ',
          beforeSend: (data) => {
            return {...data, def_status: this.estado_def}
          }
        },
        endpointExcel: 'emp_def_/downloadExcel',
        fileNameExcel: 'LiquidacionDefinitiva',
        paramsT: {}
      }
    },
    methods: {
      handleOk () {
        this.visible = false
      },
      limiteRegistroNovedad () {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina') ||
          ((this.$getConfigValue('CLIENTE_MASIVO', 'NO') === 'SI') && (this.$userIsInrol('TecnicoSS') || this.$userIsInrol('TecniNomina')))) {
          this.master.actions.push({
            name: 'masterCreate',
            text: 'Crear',
            permisos: [],
            props: {icon: 'plus', type: 'button'}
          })
        } else {
          this.httpClient.getInstance().get('tiempo_limite')
            .then(response => {
              if (response.data[0].tiempolimite !== '1') {
                this.visible = true
                this.master.actions.splice(0)
              } else {
                this.master.actions.push({
                  name: 'masterCreate',
                  text: 'Crear',
                  permisos: [],
                  props: {icon: 'plus', type: 'button'}
                })
              }
            })
            .catch(() => {
              // eslint-disable-next-line no-undef
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad')
            })
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.estado_def = 'LIQ'
            break
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            if (action.record.def_status === 'CER') {
              this.estado_def = 'CER'
              this.$refs.master.modal.form.setFieldsValue({
                estado_quemado: 'CERRADO'
              })
            } else {
              this.estado_def = 'LIQ'
              this.$refs.master.modal.form.setFieldsValue({
                estado_quemado: 'LIQUIDADO'
              })
            }
            break
        }
      },
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      id_emp () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_emp : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/EmpDef.vue